import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgtButtonComponent, TranslatePipe } from '@corporate/ng-tebis-base-components';
import { AuthService } from '../../01_core/auth/auth.service';
// import { version,message } from '../../../../../../package.json';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'tps-login',
  imports: [
    TranslatePipe,
    NgtButtonComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {

  // show version with environment name 
  // versionInfo  = `TebiProc App ${version} - ${environment.name}`;
  // versionMessage = `Version message: ${message}`; 

  authService = inject(AuthService);

}
